import { render, staticRenderFns } from "./accountinvoices.vue?vue&type=template&id=fb9b2cf6&scoped=true&"
import script from "./accountinvoices.vue?vue&type=script&lang=js&"
export * from "./accountinvoices.vue?vue&type=script&lang=js&"
import style0 from "./accountinvoices.vue?vue&type=style&index=0&id=fb9b2cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9b2cf6",
  null
  
)

export default component.exports